import { createContext, useContext, ReactNode } from 'react';

import type { WidgetPageProps } from '../../widget/Widget.props';

const PagePropsContext = createContext<WidgetPageProps | undefined>(undefined);

interface PagePropsProviderProps {
  pageProps?: WidgetPageProps;
  children: ReactNode;
}

export const PagePropsProvider = ({
  pageProps,
  children,
}: PagePropsProviderProps) => {
  return (
    <PagePropsContext.Provider value={pageProps}>
      {children}
    </PagePropsContext.Provider>
  );
};

export const usePageProps = () => {
  const context = useContext(PagePropsContext);
  return context;
};
